// extracted by css-extract-rspack-plugin
var _1 = "pjwBNVPgTtEyjNMJ";
var _2 = "vj6XCc4iw9o194AZ";
var _3 = "pzlxf3iq3PInAiOU";
var _4 = "pzlxf3iq3PInAiOU";
var _5 = "KqGyGDG_UuouQjTV";
var _6 = "KqGyGDG_UuouQjTV";
export { _1 as "divider", _2 as "header", _3 as "header--sticky", _4 as "headerSticky", _5 as "tabs-container", _6 as "tabsContainer" }
